<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'organization', params: { orgId: orgId }}">organization
            </router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'customers'}">Users</router-link>
          </div>
          <div class="text-xl text-primary">
            WiFi users
          </div>
        </div>
        <div class=""></div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="font-semibold mx-2 text-gray-600">{{ title }}</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full mb-3 ">
            <thead>
            <tr class="border-b font-bold">
              <td class="px-3 py-2"></td>
              <td class="px-3 py-2">Name</td>
              <td class="px-3 py-2">Phone Number</td>
              <td class="px-3 py-2">Email Address</td>
              <td class="px-3 py-2">Facebook</td>
              <td class="px-3 py-2">Twitter</td>
              <td class="px-3 py-2">More info</td>
              <td class="px-3 py-2"></td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-t hover:bg-gray-200" v-for="(customer,index) in customers"
                :key="customer.id">
              <td class="px-3 py-2 font-bold"> 
                {{ offset + index + 1 }}
              </td>
              <td class="px-3 py-2">
                <router-link :to="{name:'customer_profile', params:{customerId: customer.id}}">
                  {{ customer.identity }}
                </router-link>
              </td>
              <td class="px-3 py-2 whitespace-no-wrap">{{ customer.phone_number }}</td>
              <td class="px-3 py-2">{{ customer.email_address }}</td>
              <td class="px-3 py-2">{{ customer.facebook }}</td>
              <td class="px-3 py-2">{{ customer.twitter }}</td>
              <td class="px-3 py-2">{{ customer.more_info }}</td>
            </tr>
            </tbody> 
          </table>
          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
        </div>
        <Pagination class="py-2 px-3" :total-count="customerCount" :current-page="currentPage"
                    :tag="'users'"
                    :offset="offset"
                    :records-count="customers != null ? customers.length || 0 : 0"
                    :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import GraphQl from "../../services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "Customers",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      organization: Object,
      customers: [],
      customerCount: 0 ,
      orgId: this.$store.getters.orgId,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    title: {type: String, default: 'Clients'},
    devices: {type: Array, default: () => []},
    venues: {type: Array, default: () => []},
    groups: {type: Array, default: () => []},
    accessPoints: {type: Array, default: () => []},
    online: {type: Boolean, default: null},
    rowsPerPage: {type: Number, default: 10},
    authorized: {type: Boolean, default: null},
    breadcrumb: {default: true, type: Boolean},
    configs: Object
  },
  mounted() {
    this.loadStats();
  },
  watch: {
    recordsPerPage: function () {
      this.loadStats(this.currentPage)
    },
    searchString: function () {
      this.currentPage = 1;
    }
  },
  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = (this.venues.length > 0 ? 'venues:["' + this.venues.join('","') + '"],' : '') +
          (this.devices.length > 0 ? 'devices:["' + this.devices.join('","') + '"],' : '') +
          (this.accessPoints.length > 0 ? 'accessPoints:["' + this.accessPoints.join('","') + '"],' : '') +
          (this.online != null ? 'online:' + this.online + ',' : '') +
          (this.authorized != null ? 'authorized:' + this.authorized + ',' : '') +
          'limit: ' + this.recordsPerPage + ', ' +
          'offset: ' + this.offset + ', ' +
         // 'order: "created_at desc", ' +
          'search: "' + this.searchString + '"';

      let query = 'customersCount  customers(' + params + '){id name phone_number email_address twitter facebook identity more_info }'
      GraphQl.sendRequest((this.groups.length > 0 ? '{customerGroup(id:"' + this.groups[0] + '"){' + query + '}}' : '{' + query + '}'))
          .then(response => {
            this.customers = this.groups.length > 0 ? response.customerGroup.customers : response.customers;
            this.customerCount =  response.customersCount;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>
</style>